// extracted by mini-css-extract-plugin
export default {"containerLoader":"Loader_containerLoader__s0xwF","loader":"Loader_loader__+lRPl","loaderItem":"Loader_loaderItem__tRwdf","spinner-zp9dbg":"Loader_spinner-zp9dbg__gZeCC"};